// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

ion-card {
  margin: 0 10px 10px 10px;
  padding: 10px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
ion-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}
ion-card:hover .chevron {
  transform: translateX(4px);
  color: var(--ion-color-primary);
}
ion-card ion-item {
  --background: var(--ion-color-light);
  --inner-padding-end: 0px;
  --padding-start: 5px;
}
ion-card ion-item ion-img {
  width: 14px;
  height: 14px;
}
ion-card ion-item .ion-icon {
  padding-right: 10px;
}
ion-card ion-item h6 {
  font-size: 18px;
  color: #515c6f;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
}
ion-card ion-item .chevron {
  font-size: 1.25rem;
  transition: transform 0.15s ease, color 0.15s ease;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/option-item/option-item.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,aAAA;EACA,eAAA;EACA,uDAAA;AACF;AACE;EACE,2BAAA;EACA,yCAAA;AACJ;AACI;EACE,0BAAA;EACA,+BAAA;AACN;AAGE;EACE,oCAAA;EACA,wBAAA;EACA,oBAAA;AADJ;AAEI;EACE,WAAA;EACA,YAAA;AAAN;AAGI;EACE,mBAAA;AADN;AAGI;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AADN;AAII;EACE,kBAAA;EACA,kDAAA;AAFN","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nion-card {\n  margin: 0 10px 10px 10px;\n  padding: 10px;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\n\n    .chevron {\n      transform: translateX(4px);\n      color: var(--ion-color-primary);\n    }\n  }\n\n  ion-item {\n    --background: var(--ion-color-light);\n    --inner-padding-end: 0px;\n    --padding-start: 5px;\n    ion-img {\n      width: 14px;\n      height: 14px;\n    }\n\n    .ion-icon {\n      padding-right: 10px;\n    }\n    h6 {\n      font-size: 18px;\n      color: #515c6f;\n      font-weight: normal;\n      font-stretch: normal;\n      font-style: normal;\n      line-height: 1.33;\n      letter-spacing: normal;\n    }\n\n    .chevron {\n      font-size: 1.25rem;\n      transition: transform 0.15s ease, color 0.15s ease;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
